// Sponsors component use fetch api.
import 'whatwg-fetch'
import React from 'react'
import mount from '../lib/mount'
import Sponsors from '../components/Sponsors'

// Sponsors component doesn't require redux.
document.addEventListener('turbolinks:load', () => {
  const node = document.getElementById('react-sponsors')
  if (node) {
    mount(node, <Sponsors />)
  }
})
